export class Budget {
    id = -1;
    name = '';

    deserialize(data: any) {
        this.id = data.id ?? -1;
        this.name = data.name ?? '';
        return this;
    }

    static Sort(a1: Budget, a2: Budget) {
        return a1.name.localeCompare(a2.name);
    }
}
